module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.dfe56a8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.eot
// module id = 193
// module chunks = 1